var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { InvalidArgumentError } from '@lucidlink/sdk';
import { LucidDevToolsKeyFactory } from './LucidDevToolsKeyFactory';
const SHOWN_LOGS_REFETCH_INTERVAL = 100; // milliseconds
export const useShownLogs = (logs, maxNumberOfLogsShown) => {
    _react_refresh_temp_1();
    if (maxNumberOfLogsShown <= 0) {
        throw new InvalidArgumentError('"maxNumberOfLogsShown" should be positive!', `maxNumberOfLogsShown = ${maxNumberOfLogsShown}`);
    }
    const queryClient = useQueryClient();
    const queryKey = LucidDevToolsKeyFactory.shownLogs();
    const query = useQuery({
        queryKey,
        refetchInterval: SHOWN_LOGS_REFETCH_INTERVAL,
        queryFn: () => {
            const lastQueryResult = queryClient.getQueryData(queryKey);
            const newQueryResult = logs.slice(-maxNumberOfLogsShown);
            return lastQueryResult &&
                lastQueryResult.length === newQueryResult.length &&
                lastQueryResult.every((value, index) => value === newQueryResult[index])
                ? lastQueryResult
                : newQueryResult;
        },
    });
    return { query };
};
_react_refresh_temp_1(useShownLogs, "P1MtCpD9aqs271pF/qZSpv+uWas=", false, () => [useQueryClient, useQuery]);
